import classNames from 'classnames';
import * as React from 'react';

import { Icon, IconColor, IconName } from 'common/components/controls';
import { Yellow100 } from 'common/lib/colors/index';
import styles from './banner.less';

interface BannerProps {
  children: React.ReactNode;
  inlinePadding?: boolean;
  onDismiss?: () => void;
  bannerColor?: string;
  useLightText?: boolean;
  alignCloseTop?: boolean;
  shadow?: boolean;
  roundedCorners?: boolean;
}

const Banner = ({
  children,
  inlinePadding,
  onDismiss,
  bannerColor = Yellow100,
  useLightText,
  alignCloseTop,
  shadow,
  roundedCorners,
}: BannerProps) => {
  return (
    <div
      className={classNames(
        styles.bannerContainer,
        { [styles.inlinePadding]: inlinePadding },
        {
          [styles.bannerShadow]: shadow,
        },
        {
          [styles.roundedCorners]: roundedCorners,
        },
      )}
      style={{ backgroundColor: bannerColor }}
    >
      <div
        className={classNames(styles.textContent, {
          [styles.lightText]: useLightText,
        })}
      >
        {children}{' '}
      </div>
      {onDismiss && (
        <div
          className={classNames(styles.closeButton, {
            [styles.alignTop]: alignCloseTop,
          })}
          onClick={onDismiss}
          role="button"
        >
          <Icon
            name={IconName.Close}
            className={styles.icon}
            large
            color={useLightText ? IconColor.Light : IconColor.Dark}
          />
        </div>
      )}
    </div>
  );
};

export default Banner;



// WEBPACK FOOTER //
// ./app/common/components/banner/banner.tsx